// import { SwipeableDrawer as Swipeable } from "@mui/material";
import styled from "styled-components";

import color from "../../../../constants/color";
// import materialUI from "../../../../material-UI";

export const FiltersCount = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: ${color.error};
  width: 16px;
  height: 16px;
  border-radius: 100%;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavTable = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const OnPress = styled.div`
  height: 36px;
  min-width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #e0e0e0;
  width: 36px;
  position: relative;
  cursor: pointer;

  :hover {
    background-color: ${color.ice};
  }
`;

export const RowReverse = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
`;

export const Title = styled.h2`
  color: #46505a;
  font-family: "Inter";
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.015em;
  text-align: left;
  width: 100%;
`;
